import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FileUpload from "../../../components/FileUpload/FileUpload";
import { createSupport, createSupportAdmin } from "../../../redux/actions/support";
import Select from "../../../components/Select/Select";
import { setMessage } from "../../../redux/actions/auth";
import checkRole from '../../../helpers/checkRole';
import SearchBox from "../../../components/SearchBox/SearchBox";
import { getUsersSearch } from "../../../redux/actions/user";



const SupportCreatePage =()=>{
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [form,setForm]=useState({});
    const [select,setSelect]=useState('09ba716e-3597-4751-84b3-8fdf453cd042');
    const user = useSelector((state) => state.currentUser.user);
    const fullList = useSelector((state) => state.fullList);
    const [searchList, setSearchList] = useState([]); 

    const changeHandler = (event) => {
        const { id, value } = event.target;

        if (id === 'userId') {
            const { option } = event.target;

            const data = {
                userId: option.id,
                email: option.email,
                name: option.lastName + ' ' + option.firstName,
            }
            setForm({...form, ...data});

            return;
        }

        setForm({ ...form, [id]: value });
    };

    const onSearch = (e) => {
        const { id, value } = e;

        if (value.length >= 3) {
            if (id === 'allUser') {
                dispatch(getUsersSearch({allUser: value}, 'user'))
                    .then( res => {
                        setSearchList(res.user)
                    })
                    .catch( error => {
                        console.log('err: ', error);
                    })
            }

        }
    }

    const createClick=()=>{
        let data={...form};
        data.fromId = data.userId;
        delete data.userId;
        if(!data.email || data.email?.length<1){
            data.email=user.email;
        }
        data.department=select;
        if(!data.name || data.name?.length<1){
            data.name=user.lastName + ' ' + user.firstName;
        }
        data.topic=1;
        data.status = '09ba716e-3597-4751-84b3-8fdf453cd011';
        
        if (checkRole(user, 'arbitr')) {
            dispatch(createSupportAdmin(data)).then(res=>{
                dispatch(setMessage({
                    message: 'Запит створено',
                    type: 'success',
                  })).then(ress=>{
                    navigate('/supportRoom/'+res.id);
                  })
            })
        } else {
            delete data.fromId;
            dispatch(createSupport(data)).then(res=>{
                dispatch(setMessage({
                    message: 'Запит створено',
                    type: 'success',
                  })).then(ress=>{
                    navigate('/supportRoom/'+res.id);
                  })
            })
        }
    }


    return (
        <>
            <div className="profileSection createSupportPage" style={{marginBottom:'0px'}}>
                <div className="prFlexRow profileSectionHeader" style={{marginBottom:'40px'}}>
                    <h2 >
                        Новий запит
                    </h2>
                </div>

                <div className="dFlex" style={{gap:'21px'}}>
                    <div className="supportAlign supportAlignCenter">
                        <div className="createSupport createSupportLeft">
                            <div className="createSupportHeader">Інформація для ознайомлення</div>
                            <div className="createSupportText">
                                Перш ніж створювати звернення, рекомендуємо переглянути <a href="https://rivalsroom.com/baza-znan" target="_blank"><strong>Базу знань</strong></a>, де зібрані відповіді на найпоширеніші питання. Це може допомогти вам знайти вирішення проблеми без очікування відповіді від технічної підтримки.
                            </div>
                            <div className="createSupportText">
                                Якщо вам все ж потрібно звернутися до служби підтримки, будь ласка, дотримуйтеся таких рекомендацій:
                            </div>
                            <div className="createSupportText">
                                <ul>
                                    <li><strong>Чітко сформулюйте проблему</strong> – вкажіть, що саме не працює або яку помилку ви отримуєте.</li>
                                    <li><strong>Додайте важливі деталі</strong> – наприклад, номер замовлення, версію вашої операційної системи або браузера.</li>
                                    <li><strong>Прикріпіть знімки екрана або файли</strong> (до 3-х файлів), які допоможуть швидше зрозуміти проблему.</li>
                                    <li><strong>Виберіть відповідний відділ</strong> – це прискорить обробку вашого запиту.</li>
                                </ul>
                            </div>
                            <div className="createSupportText">
                                Якщо вам потрібно передати більше файлів, скористайтеся посиланням на <strong>Dropbox</strong> або <strong>Google Drive</strong>.
                            </div>
                        </div>
                        <button className="prButton prButtonMain" style={{margin:'34px 0',alignSelf:'center'}} onClick={()=>navigate('/supportList')}>До списку запитів</button>
                    </div>
                   
                    <div className="supportAlign">
                        <div className="createSupport">
                            <div className="createSupportHeader">
                                Заповність форму звернення
                            </div>
                            <div className="createSupportForm">
                                <div className="createSupportFormLabel">
                                    Оберіть відділ
                                </div>
                                <div className="prFlexRow">
                                    <div
                                        className={select=='09ba716e-3597-4751-84b3-8fdf453cd042'?"forSelect active":"forSelect"}
                                        onClick={()=>setSelect('09ba716e-3597-4751-84b3-8fdf453cd042')}
                                    >
                                        <div className="createSelectItem">
                                            Технічний відділ
                                        </div>
                                        <div className="createSelectText">
                                            Технічні несправності та інші нюанси роботи із Системою
                                        </div>
                                    </div>
                                    <div
                                        className={select=='09ba716e-3597-4751-84b3-8fdf453cd041'?"forSelect active":"forSelect"}
                                        onClick={()=>setSelect('09ba716e-3597-4751-84b3-8fdf453cd041')}
                                    >
                                        <div className="createSelectItem">
                                            Фінансовий відділ
                                        </div>
                                        <div className="createSelectText">
                                            Питання оплати, ведденя, виведення коштів
                                        </div>
                                    </div>
                                </div>
                                <div className="dFlex createFormInputs">
                                    {user && checkRole(user, 'arbitr') && (
                                        <div className="prInput">
                                            <label htmlFor="userId" className={"prInputLabel"}>Користувач</label>
                                            <SearchBox
                                                id="allUser"
                                                filterId="userId"
                                                onSearch={onSearch}
                                                options={searchList}
                                                onChange={changeHandler}
                                                value={form.userId || null}
                                                valueField="id"
                                                titleField="nickname"
                                                returnWholeObj
                                            />
                                        </div>
                                    )}
                                    {user && !checkRole(user, 'arbitr') && (
                                        <>
                                            <div className="prInput">
                                                <label htmlFor="name" className={"prInputLabel"}>{t("Ім’я")}</label>
                                                <input onChange={changeHandler} value={form.name || (user?.firstName?.length>0  && user?.lastName?.length>0 &&user?.lastName+' '+ user?.firstName)||''} id="name" type="text" className={"prInputInput"} placeholder={t("enter_value")} />
                                            </div>
                                            <div className="prInput">
                                                <label htmlFor="email" className={"prInputLabel"}>{t("Email")}</label>
                                                <input onChange={changeHandler} value={form.email || user.email} id="email" type="text" className={"prInputInput"} placeholder={t("enter_value")} />
                                            </div>
                                        </>
                                    )}
                                    <div className="prInput">
                                        <label htmlFor="priority" className={"prInputLabel"}>{t("Приорітет")}</label>
                                        <Select
                                            id="priority"
                                            value={form.priority || ''}
                                            onChange={changeHandler}
                                            placeholder="Нічого не обрано"
                                            options={
                                                fullList.Priority.length > 0 &&
                                                fullList.Priority
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="prInput">
                                    <label htmlFor="message" className={"prInputLabel"}>{t("Напишіть повідомлення")}</label>
                                    <textarea onChange={changeHandler} id="message" value={form.message} placeholder={t("enter_value")} cols="30" rows="5"></textarea>
                                </div>
                            </div>
                            <div className="createSupportText">
                                Ви можете завантажити до 3 файлів у одному повідомленні. Якщо хочете передати нам більше файлів, можете використати посилання на Dropbox чи Google Drive
                            </div>
                            <div>
                                <FileUpload id={'img'} form={form} setForm={setForm} maxFiles={3}></FileUpload>
                            </div>
                        </div>

                        <div className="buttonsGap">
                            <button className="prButton prButtonSecond" onClick={()=>navigate('/supportList')}>Відмінити</button>
                            <button className="prButton prButtonMain" onClick={createClick}>Надіслати</button>
                        </div>
                    </div>
                </div>

            </div>


        </>
    )
}


export default SupportCreatePage;